import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  Divider,
  Grid,
  IconButton,
  InputLabel,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  colorPrimary,
  colorSecondary,
  colorTextBlack,
  colorTextGrey
} from '../../../config/theme';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { handleError, isArrayNotEmpty } from '../../../utils/utils';
import SnackBarBox from '../../../components/SnackBarBox';
import {
  gamification,
  shareDetails
} from '../../../redux/reducers/resourcesSlice';

function ShareButtonDialog({ isOpen, onClose, data }) {
  const dispatch = useDispatch();
  const [isSharePAFUser, setIsSharePAFUser] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isCopySuccess, setIsCopySuccess] = useState(false);
  const [event, setEvent] = useState(null);

  const { usersData } = useSelector(state => state.users);
  const { authData } = useSelector(state => state.auth);
  const { isShareDetailsLoading, isShareDetailsSuccess } = useSelector(
    state => state.resource
  );
  const shareLink = `${process.env.REACT_APP_PORTAL_URL}content-space/view?id=${data?.encrypted_content_id}`;

  useEffect(() => {
    setTimeout(() => {
      setIsCopySuccess(false);
    }, 2000);
  }, [isCopySuccess]);

  useEffect(() => {
    if (!isShareDetailsLoading && isShareDetailsSuccess) {
      handleClose(event);
    }
  }, [isShareDetailsLoading, isShareDetailsSuccess]);

  const handleChange = (event, newValue) => {
    event.stopPropagation();
    setSelectedOptions(newValue);
  };

  const handlePAFPeopleClick = e => {
    setEvent(e);
    e.stopPropagation();
    setIsSharePAFUser(!isSharePAFUser);
  };

  const handleCopyLink = e => {
    e.stopPropagation();
    setIsSharePAFUser(false);
    if (data?.encrypted_content_id) {
      navigator.clipboard.writeText(shareLink).then(
        () => {
          setIsCopySuccess(true);
          onClose();
        },
        err => {
          console.error('Failed to copy link: ', err);
        }
      );
    }
  };

  const handleShareWhatsApp = e => {
    e.stopPropagation();
    if (authData?.role === 'I am a student') {
      if (data?.allow_points) {
        let gamificationPayload = {
          userId: authData?.userId || 0,
          contentId: data?.content_id || data?.contentId || 0,
          point: data?.share_points || 0,
          type: 'share',
          loggedInUserName: authData?.userName || ''
        };
        dispatch(gamification({ gamificationPayload }));
      }
    }
    setIsSharePAFUser(false);
    if (data?.encrypted_content_id) {
      const whatsappURL = `https://web.whatsapp.com/send?text=${encodeURIComponent(shareLink)}`;
      window.open(whatsappURL, '_blank');
    }
    onClose();
  };

  const handleClose = e => {
    setIsSharePAFUser(false);
    setSelectedOptions([]);
    onClose(e);
    setEvent(e);
  };

  const handleShareDetails = e => {
    e.stopPropagation();
    let temSelectedOptions = [...selectedOptions];

    let selectedIds = temSelectedOptions.map((item, i) => {
      return item.id;
    });

    let payload = {
      contentId: data?.content_id || data?.contentId || 0,
      userIds: selectedIds.join(',') || '',
      loggedInUserName: authData?.userName || ''
    };
    dispatch(shareDetails({ payload }));
    if (authData?.role === 'I am a student') {
      if (data?.allow_points) {
        let gamificationPayload = {
          userId: authData?.userId || 0,
          contentId: data?.content_id || data?.contentId || 0,
          point: data?.share_points || 0,
          type: 'share',
          loggedInUserName: authData?.userName || ''
        };
        dispatch(gamification({ gamificationPayload }));
      }
    }
  };

  return (
    <>
      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '8px'
          }
        }}
        open={isOpen}
        onClose={e => handleClose(e)}
      >
        <Box sx={{ padding: '40px' }}>
          <Typography fontSize={'20px'} fontWeight={700} marginBottom="16px">
            Share
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            width={'296px'}
            marginBottom={'16px'}
          >
            <Box>
              <IconButton
                sx={{
                  height: '48px',
                  width: '48px',
                  border: 'solid #E4E7EB 1px',
                  borderRadius: '50%',
                  backgroundColor: '#F5F7FA',
                  marginBottom: '4px'
                }}
                onClick={handleCopyLink}
              >
                <svg
                  width="21"
                  height="22"
                  viewBox="0 0 21 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_2506_29408)">
                    <path
                      d="M7.07059 7.57157V5.17157C7.07059 4.21148 7.07059 3.73143 7.25744 3.36473C7.42179 3.04216 7.68404 2.77991 8.00661 2.61556C8.37331 2.42871 8.85336 2.42871 9.81345 2.42871H16.3277C17.2878 2.42871 17.7679 2.42871 18.1346 2.61556C18.4571 2.77991 18.7194 3.04216 18.8837 3.36473C19.0706 3.73143 19.0706 4.21148 19.0706 5.17157V11.6859C19.0706 12.6459 19.0706 13.126 18.8837 13.4927C18.7194 13.8153 18.4571 14.0775 18.1346 14.2419C17.7679 14.4287 17.2878 14.4287 16.3277 14.4287H13.9277M4.67059 19.5716H11.1849C12.145 19.5716 12.625 19.5716 12.9917 19.3847C13.3143 19.2204 13.5765 18.9581 13.7409 18.6356C13.9277 18.2688 13.9277 17.7888 13.9277 16.8287V10.3144C13.9277 9.35434 13.9277 8.87429 13.7409 8.50758C13.5765 8.18502 13.3143 7.92277 12.9917 7.75841C12.625 7.57157 12.145 7.57157 11.1849 7.57157H4.67059C3.7105 7.57157 3.23046 7.57157 2.86375 7.75841C2.54119 7.92277 2.27893 8.18502 2.11458 8.50758C1.92773 8.87429 1.92773 9.35434 1.92773 10.3144V16.8287C1.92773 17.7888 1.92773 18.2688 2.11458 18.6356C2.27893 18.9581 2.54119 19.2204 2.86375 19.3847C3.23046 19.5716 3.7105 19.5716 4.67059 19.5716Z"
                      stroke="#1F2933"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2506_29408">
                      <rect
                        width="20.5714"
                        height="20.5714"
                        fill="white"
                        transform="translate(0.213867 0.714355)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </IconButton>
              <Box
                sx={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: colorTextBlack
                }}
              >
                Copy Link
              </Box>
            </Box>
            <Box>
              <IconButton
                sx={{
                  height: '48px',
                  width: '48px',
                  border: 'solid #E4E7EB 1px',
                  borderRadius: '50%',
                  backgroundColor: '#F5F7FA',
                  marginBottom: '4px'
                }}
                onClick={handleShareWhatsApp}
              >
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.8676 3.50271C18.6622 1.2324 15.6136 0 12.5 0C5.8838 0 0.564886 5.3838 0.629772 11.9351C0.629772 14.0108 1.21357 16.0216 2.18651 17.8378L0.5 24L6.79194 22.3784C8.54326 23.3513 10.4892 23.8054 12.4351 23.8054C18.9865 23.8054 24.3054 18.4216 24.3054 11.8702C24.3054 8.69186 23.073 5.70814 20.8676 3.50271ZM12.5 21.7946C10.7487 21.7946 8.99729 21.3405 7.50543 20.4324L7.1162 20.2378L3.35411 21.2108L4.32706 17.5135L4.0676 17.1243C1.21357 12.5189 2.57566 6.42163 7.24597 3.5676C11.9162 0.713511 17.9487 2.07566 20.8027 6.74597C23.6567 11.4162 22.2947 17.4487 17.6243 20.3027C16.1325 21.2757 14.3162 21.7946 12.5 21.7946ZM18.2081 14.5946L17.4947 14.2702C17.4947 14.2702 16.4567 13.8162 15.8081 13.4919C15.7433 13.4919 15.6784 13.4271 15.6136 13.4271C15.4189 13.4271 15.2892 13.4919 15.1595 13.5567C15.1595 13.5567 15.0947 13.6216 14.1865 14.6595C14.1216 14.7892 13.9919 14.854 13.8622 14.854H13.7973C13.7325 14.854 13.6027 14.7892 13.5378 14.7243L13.2136 14.5946C12.5 14.2702 11.8514 13.8811 11.3325 13.3622C11.2027 13.2324 11.0081 13.1027 10.8784 12.9729C10.4243 12.5189 9.97031 12 9.64597 11.4162L9.58109 11.2865C9.5162 11.2216 9.5162 11.1567 9.4514 11.0271C9.4514 10.8973 9.4514 10.7676 9.5162 10.7027C9.5162 10.7027 9.77566 10.3784 9.97032 10.1838C10.1 10.054 10.1649 9.85946 10.2947 9.72977C10.4243 9.53511 10.4892 9.27566 10.4243 9.08109C10.3595 8.75674 9.58109 7.00543 9.38651 6.6162C9.25674 6.42163 9.12706 6.35674 8.93249 6.29186H8.73783C8.60814 6.29186 8.41357 6.29186 8.21891 6.29186C8.08923 6.29186 7.95946 6.35674 7.82977 6.35674L7.76489 6.42163C7.63511 6.48651 7.50543 6.6162 7.37566 6.68109C7.24597 6.81077 7.18109 6.94054 7.0514 7.07023C6.59729 7.65403 6.33783 8.3676 6.33783 9.08109C6.33783 9.6 6.4676 10.1189 6.66217 10.5729L6.72706 10.7676C7.31086 12 8.08923 13.1027 9.12706 14.0757L9.38651 14.3351C9.58109 14.5298 9.77566 14.6595 9.90543 14.854C11.2676 16.0216 12.8243 16.8649 14.5757 17.3189C14.7703 17.3838 15.0298 17.3838 15.2243 17.4487C15.4189 17.4487 15.6784 17.4487 15.873 17.4487C16.1973 17.4487 16.5865 17.3189 16.846 17.1892C17.0405 17.0595 17.1703 17.0595 17.3 16.9298L17.4298 16.8C17.5595 16.6702 17.6892 16.6054 17.8189 16.4757C17.9487 16.346 18.0784 16.2162 18.1433 16.0865C18.273 15.8271 18.3378 15.5027 18.4027 15.1784C18.4027 15.0487 18.4027 14.854 18.4027 14.7243C18.4027 14.7243 18.3378 14.6595 18.2081 14.5946Z"
                    fill="#1F2933"
                  />
                </svg>
              </IconButton>
              <Box
                sx={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: colorTextBlack
                }}
              >
                WhatsApp
              </Box>
            </Box>
            <Box>
              <IconButton
                sx={{
                  height: '48px',
                  width: '48px',
                  border:
                    isSharePAFUser === true
                      ? 'solid #F4C24A 1px'
                      : 'solid #E4E7EB 1px',

                  borderRadius: '50%',
                  backgroundColor:
                    isSharePAFUser === true ? '#FEF8EC' : '#F5F7FA',
                  marginBottom: '4px'
                }}
                onClick={handlePAFPeopleClick}
              >
                <svg
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.6427 12.2887C16.8906 12.9156 17.9605 13.9216 18.7415 15.1796C18.8961 15.4287 18.9735 15.5533 19.0002 15.7258C19.0545 16.0763 18.8148 16.5072 18.4884 16.646C18.3277 16.7142 18.147 16.7142 17.7856 16.7142M13.9284 8.59899C15.1985 7.96784 16.0713 6.65724 16.0713 5.14279C16.0713 3.62834 15.1985 2.31774 13.9284 1.68658M12.2141 5.14279C12.2141 7.27303 10.4872 8.99993 8.357 8.99993C6.22676 8.99993 4.49986 7.27303 4.49986 5.14279C4.49986 3.01255 6.22676 1.28564 8.357 1.28564C10.4872 1.28564 12.2141 3.01255 12.2141 5.14279ZM2.40777 14.9471C3.77432 12.8953 5.93075 11.5714 8.357 11.5714C10.7833 11.5714 12.9397 12.8953 14.3062 14.9471C14.6056 15.3966 14.7553 15.6213 14.7381 15.9084C14.7246 16.132 14.5781 16.4056 14.3995 16.5407C14.1701 16.7142 13.8546 16.7142 13.2236 16.7142H3.49045C2.85944 16.7142 2.54393 16.7142 2.31452 16.5407C2.1359 16.4056 1.98936 16.132 1.97595 15.9084C1.95871 15.6213 2.1084 15.3966 2.40777 14.9471Z"
                    stroke={isSharePAFUser === true ? '#F4C24A' : '#1F2933'}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
              <Box
                sx={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: colorTextBlack
                }}
              >
                PAF People
              </Box>
            </Box>
          </Box>
          {isSharePAFUser && (
            <>
              <Divider />
              <Box
                sx={{ marginTop: '16px', width: '379px', maxWidth: '379px' }}
              >
                <InputLabel
                  sx={{
                    fontWeight: '700',
                    color: colorTextBlack,
                    fontSize: '16px',
                    mb: 0.6
                  }}
                >
                  Select PAF users
                </InputLabel>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  size="small"
                  loading={true}
                  options={
                    isArrayNotEmpty(usersData.userList)
                      ? usersData.userList.map(cc => {
                          return { id: cc.userId, label: cc.name };
                        })
                      : []
                  }
                  getOptionLabel={option => `${option.label}`}
                  isOptionEqualToValue={(option, value) =>
                    option.label === (value ? value.label : null)
                  }
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} sx={{ marginRight: 8 }} />
                      {option.label}
                    </li>
                  )}
                  ListboxProps={{
                    sx: {
                      '& .MuiAutocomplete-option:hover': {
                        backgroundColor: colorSecondary
                      }
                    }
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                          paddingLeft: '12px'
                        }
                      }}
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <svg
                              width="17"
                              height="16"
                              viewBox="0 0 17 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18 17.5L14.375 13.875M16.3333 9.16667C16.3333 12.8486 13.3486 15.8333 9.66667 15.8333C5.98477 15.8333 3 12.8486 3 9.16667C3 5.48477 5.98477 2.5 9.66667 2.5C13.3486 2.5 16.3333 5.48477 16.3333 9.16667Z"
                                stroke={colorTextGrey}
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            {params.InputProps.startAdornment}
                          </>
                        )
                      }}
                    />
                  )}
                  value={selectedOptions}
                  onChange={handleChange}
                />
              </Box>
              <Grid
                mt={2}
                item
                display={'flex'}
                justifyContent={'start'}
                gap={2}
              >
                <Button
                  variant="outlined"
                  onClick={onClose}
                  sx={{
                    px: 4,
                    borderColor: colorPrimary,
                    borderRadius: '10px',
                    color: 'black',
                    borderWidth: '2px',
                    height: '42px',
                    width: '106px',
                    '&:hover': {
                      borderColor: colorPrimary,
                      backgroundColor: 'transparent',
                      borderRadius: '10px',
                      borderWidth: '2px'
                    }
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  disabled={!(selectedOptions.length > 0)}
                  sx={{ mr: 2, px: 4, borderWidth: 2, width: '95px' }}
                  onClick={e => handleShareDetails(e)}
                >
                  {isShareDetailsLoading ? (
                    <CircularProgress size={22} color="inherit" />
                  ) : (
                    'Send'
                  )}
                </Button>
              </Grid>
            </>
          )}
        </Box>
      </Dialog>
      {isCopySuccess && (
        <SnackBarBox
          type="success"
          message={handleError('Link copied to clipboard!')}
        />
      )}
    </>
  );
}

export default ShareButtonDialog;
